// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parent-wrapper{max-width:49%}.parent-wrapper,.to{display:inline-block;vertical-align:top}.to{max-width:5%;height:100%;padding-top:5px;padding-right:5px}.child-wrapper{max-width:47%;display:inline-block}", ""]);
// Exports
module.exports = exports;
